import React from 'react'
import clsx from 'clsx'
import { Controller, useFormContext } from 'react-hook-form'
import { Checkbox, CheckboxProps, FormHelperText, FormControlLabel } from '@mui/material'

import withFormFunctionality, { FormElementProps } from '~shared/components/reactHookForm/withFormFunctionality.hoc'
import { useFormInputStyles } from '~shared/components/reactHookForm/input/FormInputStyles'

// improvement proposal -- implement modifying value onChange
type Props = Omit<CheckboxProps, 'value'> & FormElementProps & {
  // improvement proposal -- to stay consistend we could use label instead of text here
  // to do this we have to fix the type problems this causes
  text?: string | React.ReactNode
  dontAlignTextTop?: boolean
}

const FormCheckbox: React.FC<Props> = (props) => {
  const s = useFormInputStyles()
  // improvement proposal -- find a way to either remove label from possible props, or use label instead of text
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- label has to be extracted since it is allowed in withFormFunctionality
  const { validationError, defaultValue, helperText, label, text, ...rest } = props
  const { control } = useFormContext()
  // todo - how to show that this is required

  return <Controller
    control={control}
    name={props.name}
    defaultValue={defaultValue || false}
    render={(controllerProps) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- presetting this should help when implementing custom onChange
      const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        controllerProps.onChange(checked)
      }

      return <div>
        <FormControlLabel
          label={text}
          className={clsx(!props.dontAlignTextTop && s.alignCheckboxTop)}
          control={
            <Checkbox
              value={controllerProps.value}
              {...rest}
              onChange={handleOnChange}
              required
            />
          }
        />
        {
          (validationError || helperText)
          && <FormHelperText error={!!validationError}>{validationError?.message || helperText}</FormHelperText>
        }
      </div>
    }}
  />
}

export default withFormFunctionality<Props>(FormCheckbox)
